import { RespondentCounts, RespondentCount } from 'generated/types'

export const responseCount = (resultSlug: string, respondentCounts: RespondentCounts) => {
  const rc = respondentCounts.respondentCounts.find((rc: RespondentCount) => rc.option.slug === resultSlug)

  if (respondentCounts.totalRespondents === 0) {
    return null
  }

  if (!rc) {
    return 0
  }

  return Math.round((rc.respondents / respondentCounts.totalRespondents) * 100)
}

export interface ChartColors {
  [propName: string]: string
}

export interface ChartLabels {
  [propName: string]: string
}

export const respondentsToBarChartData = (
  respondents: RespondentCounts,
  chartColors: ChartColors,
  chartLabels?: ChartLabels,
  optionOrder?: string[],
) => {
  const options = respondents.respondentCounts.map((rc) => rc.option)
  const order = optionOrder || options.map((o) => o.slug)

  const datasets = order.map((optionSlug, i) => {
    const option = options.find((o) => o.slug === optionSlug)
    if (!option) {
      throw new Error(`option with slug ${optionSlug} not found in ${options}`)
    }

    const chartColorKeys = Object.keys(chartColors)
    const bgColor = chartColors[option.slug!]
      ? chartColors[option.slug!]
      : chartColors[chartColorKeys[i % chartColorKeys.length]]
    const label = chartLabels && chartLabels[option.slug!] ? chartLabels[option.slug!] : option.text

    return {
      data: [responseCount(option.slug!, respondents)].filter((v) => v !== null),
      backgroundColor: bgColor,
      label,
      maxBarThickness: 50,
    }
  })

  return { datasets }
}

export const respondentsToDoughnutChartData = (
  respondents: RespondentCounts,
  chartColors: ChartColors,
  chartLabels?: ChartLabels,
  optionOrder?: string[],
) => {
  const options = respondents.respondentCounts.map((rc) => rc.option)
  const chartColorKeys = Object.keys(chartColors)
  const order = optionOrder || options.map((o) => o.slug!)

  let data = order.map((slug) => responseCount(slug, respondents))
  if (data.every((v) => v === null)) {
    data = []
  }

  return {
    datasets: [
      {
        data,
        backgroundColor: order.map((slug, i) => (
          chartColors[slug] ? chartColors[slug] : chartColors[chartColorKeys[i % chartColorKeys.length]])),
        borderWidth: 0,
      },
    ],
    labels: order.map((slug) => (
      chartLabels && chartLabels[slug] ? chartLabels[slug] : options.find((o) => o.slug === slug)!.text)),
  }
}
